/**
 * https://hackernoon.com/angular-simple-in-memory-cache-service-on-the-ui-with-rxjs-77f167387e39
 */

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Rx';
import { Injectable } from '@angular/core';

interface CacheContent {
  expiry: number;
  value: any;
}

/**
 * Cache Service is an observables based in-memory cache implementation
 * Keeps track of in-flight observables and sets a default expiry for cached values
 * @export
 * @class CacheService
 */
@Injectable()
export class RoutingParameterService {

  constructor() {
  }

  parameters: any;

  clear():void
  {
    this.parameters=null;
  }

}


// WEBPACK FOOTER //
// ./src/app/_services/routing-parameters.service.ts